/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createCreditCardsOverviewGetResponseFromDiscriminatorValue, type CreditCardsOverviewGetResponse } from '../../models';
// @ts-ignore
import { type BaseRequestBuilder, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /creditcards/overview
 */
export interface OverviewRequestBuilder extends BaseRequestBuilder<OverviewRequestBuilder> {
    /**
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<CreditCardsOverviewGetResponse>}
     */
     get(requestConfiguration?: RequestConfiguration<OverviewRequestBuilderGetQueryParameters> | undefined) : Promise<CreditCardsOverviewGetResponse | undefined>;
    /**
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toGetRequestInformation(requestConfiguration?: RequestConfiguration<OverviewRequestBuilderGetQueryParameters> | undefined) : RequestInformation;
}
export interface OverviewRequestBuilderGetQueryParameters {
    asAt?: Date;
}
/**
 * Uri template for the request builder.
 */
export const OverviewRequestBuilderUriTemplate = "{+baseurl}/creditcards/overview{?asAt*}";
/**
 * Metadata for all the requests in the request builder.
 */
export const OverviewRequestBuilderRequestsMetadata: RequestsMetadata = {
    get: {
        uriTemplate: OverviewRequestBuilderUriTemplate,
        responseBodyContentType: "application/json, text/plain;q=0.9",
        adapterMethodName: "send",
        responseBodyFactory:  createCreditCardsOverviewGetResponseFromDiscriminatorValue,
    },
};
/* tslint:enable */
/* eslint-enable */
